import { useLoginContext } from '../../../App';
import { useMemo } from 'react';

const useGettingLoginData = () => {
    const { loginData, setLoginData } = useLoginContext();

    const storedLoginData = useMemo(() => {
        if (loginData) {
            return loginData;
        }
        const localStorageData = localStorage.getItem('loginData');
        if (localStorageData) {
            const parsedData = JSON.parse(localStorageData);
            setLoginData(parsedData); // Update context with stored data
            return parsedData;
        } else {
            return null; // No login data available
        }
    }, [loginData]);

    return storedLoginData;
};

export default useGettingLoginData;
